import { Actions, actionLoadingName, actionSuccessName, actionErrorName } from '../actions'

const _buildUI = (currentAction, baseAction) => ({
   isLoading: actionLoadingName(baseAction) === currentAction,
   isError: actionErrorName(baseAction) === currentAction,
})

const initialState = {
   login: {},
   agendas: {},
   agendaReports: {},
   agendaWeekAppointments: {},
   createAppointment: {},
   teleHealthAppointmentCredentials: {
      isError: false,
      isLoading: false,
   },
   showConfirmDialog: false,
   showCancelDialog: false,
   promptAppointment: null,
   timeslots: {}
}

const ui = (state = initialState, action) => {

   switch (action.type) {

      case actionLoadingName(Actions.LOG_IN):
      case actionSuccessName(Actions.LOG_IN):
      case actionErrorName(Actions.LOG_IN):
         return { ...state, login: _buildUI(action.type, Actions.LOG_IN) }

      case actionLoadingName(Actions.GET_AGENDAS):
      case actionSuccessName(Actions.GET_AGENDAS):
      case actionErrorName(Actions.GET_AGENDAS):
         return { ...state, agendas: _buildUI(action.type, Actions.GET_AGENDAS) }

      case actionLoadingName(Actions.GET_AGENDA_REPORT):
      case actionSuccessName(Actions.GET_AGENDA_REPORT):
      case actionErrorName(Actions.GET_AGENDA_REPORT):
         return { ...state, agendaReports: _buildUI(action.type, Actions.GET_AGENDA_REPORT) }

      case actionLoadingName(Actions.GET_AGENDA_WEEK_APPOINTMENTS):
      case actionSuccessName(Actions.GET_AGENDA_WEEK_APPOINTMENTS):
      case actionErrorName(Actions.GET_AGENDA_WEEK_APPOINTMENTS):
         return { ...state, agendaWeekAppointments: _buildUI(action.type, Actions.GET_AGENDA_WEEK_APPOINTMENTS) }

      case actionLoadingName(Actions.CREATE_APPOINTMENT):
      case actionSuccessName(Actions.CREATE_APPOINTMENT):
      case actionErrorName(Actions.CREATE_APPOINTMENT):
         return { ...state, createAppointment: _buildUI(action.type, Actions.CREATE_APPOINTMENT) }

      case actionLoadingName(Actions.GET_TELEHEALTH_APPOINTMENT_CREDENTIALS):
      case actionSuccessName(Actions.GET_TELEHEALTH_APPOINTMENT_CREDENTIALS):
      case actionErrorName(Actions.GET_TELEHEALTH_APPOINTMENT_CREDENTIALS):
         return { ...state, teleHealthAppointmentCredentials: _buildUI(action.type, Actions.GET_TELEHEALTH_APPOINTMENT_CREDENTIALS) }

      case Actions.PROMPT_COMPLETE_APPOINTMENT:
      case Actions.PROMPT_CANCEL_APPOINTMENT:
      case Actions.PROMPT_DIALOG_CLOSE:
         return {
            ...state,
            promptAppointment: action.payload,
            showConfirmDialog: action.type === Actions.PROMPT_COMPLETE_APPOINTMENT, showCancelDialog: action.type === Actions.PROMPT_CANCEL_APPOINTMENT
         }

      case Actions.OPEN_APPOINTMENT:
      case Actions.CLOSE_APPOINTMENT:
      case Actions.CANCEL_APPOINTMENT:
      case Actions.COMPLETE_APPOINTMENT:
         return {
            ...state,
            timeslots: {
               ...state.timeslots,
               [action.payload.id]: { isLoading: true, isError: false }
            }
         }

      case actionSuccessName(Actions.OPEN_APPOINTMENT):
      case actionSuccessName(Actions.CLOSE_APPOINTMENT):
      case actionSuccessName(Actions.CANCEL_APPOINTMENT):
      case actionSuccessName(Actions.COMPLETE_APPOINTMENT):
         return {
            ...state,
            timeslots: {
               ...state.timeslots,
               [action.response.result]: { isLoading: false, isError: false }
            }
         }

      case actionErrorName(Actions.OPEN_APPOINTMENT):
      case actionErrorName(Actions.CLOSE_APPOINTMENT):
      case actionErrorName(Actions.CANCEL_APPOINTMENT):
      case actionErrorName(Actions.COMPLETE_APPOINTMENT):
         return {
            ...state,
            timeslots: {
               ...state.timeslots,
               [action.response.result]: { isLoading: false, isError: true }
            }
         }

      default:
         return state
   }

}

export default ui



// WEBPACK FOOTER //
// ./src/state/reducers/ui.js